/**
 * Created by asiulik on 24.11.2017.
 */

define(['jquery', 'lodash', 'eventEmitter/EventEmitter', 'slick'], function ($, _, EventEmitter) {

    var HOME_SLIDE_ACTIVE_CLASS = 'home__slide--active';

    function Home() {
    }

    Home.prototype = _.clone(EventEmitter.prototype);

    Home.prototype.init = function () {


        var _this = this;
        var $sliderElement = $('.t__home__slider__content');
        var $slides = $sliderElement.find('.m__slider__item');

        $sliderElement.slick({
            arrows: false,
            dots: true,
            speed: 1000,
            autoplay: true,
            pauseOnHover: false,
            autoplaySpeed: $sliderElement.data('sliderInterval') || 2000
        });

        $sliderElement.on('beforeChange', function (event, slick, currentSlide, nextSlide) {

            var $currentSlide = $slides.eq(currentSlide);
            $currentSlide.addClass(HOME_SLIDE_ACTIVE_CLASS);

        });

        $sliderElement.on('afterChange', function (event, slick, currentSlide, nextSlide) {

            $slides.removeClass(HOME_SLIDE_ACTIVE_CLASS);
            $slides.eq(currentSlide).addClass(HOME_SLIDE_ACTIVE_CLASS)


        });

        var $clonedSlides = $sliderElement.find('.slick-cloned');
        setTimeout(function () {
            _this.emit('home:preloadClonedImages', $clonedSlides)
        }, 2000)


    };

    return Home;

});



// WEBPACK FOOTER //
// ./Private/Scripts/pages/home.js